import { render } from "./FloatingIcons.vue?vue&type=template&id=d8da837a&scoped=true"
import script from "./FloatingIcons.vue?vue&type=script&lang=js"
export * from "./FloatingIcons.vue?vue&type=script&lang=js"

import "./FloatingIcons.vue?vue&type=style&index=0&id=d8da837a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8da837a"]])

export default __exports__